/**
 * Project images
 */
export const project1 = [
    {
        "id": 0,
        "src": "bustracker.png",
        "alt": "Bustracker screenshot"
    }
]

export const project2 = [
    {
        "id": 0,
        "src": "texttwist1.png",
        "alt": "Text twist game instructions screenshot"
    },
    {
        "id": 1,
        "src": "texttwist2.png",
        "alt": "Text twist gameplay screenshot"
    }
]

export const project3 = [
    {
        "id": 0,
        "src": "site1.png",
        "alt": "Picture of this website"
    },
    {
        "id": 1,
        "src": "site2.png",
        "alt": "Another picture of this site"
    },
    {
        "id": 2,
        "src": "site3.png",
        "alt": "A third picture of this site"
    }
]
